import {getCustLinks} from 'data/DataStore';

function useLocalProtocol(src) {
	if (src) {
		let localUrl = src;

		if (localUrl.startsWith("http://")) {
			localUrl = src.substring(5);
		}
		else if (localUrl.startsWith("https://")) {
			localUrl = src.substring(6);
		}
		else if (!localUrl.startsWith("//")) {
			localUrl = "//" + localUrl;
		}

		return localUrl;
	}

	return src;
}
/**
 * Retrieves the custom link replacements and appends it to the given url.
 * @param {string} url 
 */
function appendCustomReplacementLinksToUrl(url) {
	let custLinkReplacements = getCustLinks();
	if(custLinkReplacements)
		return `${url}${custLinkReplacements}`;
	else 
		return url;
}

export { useLocalProtocol, appendCustomReplacementLinksToUrl }



// WEBPACK FOOTER //
// ./src/lib/UrlUtilities.js